/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_ListInputs */



/**
* | output |
* | --- |
* | "Enable List" |
*
* @param {Enable_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_list = /** @type {((inputs?: Enable_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer la liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Liste aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de habilitación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リストを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूची सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar lista")
	return /** @type {LocalizedString} */ ("Enable List")
});